export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 p-6 text-center text-sm text-gray-500">
      <div
        className="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-brand"
        aria-hidden
      />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({
  title,
  message,
  onRetry,
}: {
  title: string;
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex h-full flex-col items-center justify-center p-6 text-center">
      <div className="text-3xl" aria-hidden>
        ⚠️
      </div>
      <h2 className="mt-3 text-base font-semibold">{title}</h2>
      <p className="mt-2 max-w-sm text-sm text-gray-600">{message}</p>
      {onRetry && (
        <button type="button" className="btn-secondary mt-4" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}

export function SignInPrompt({ onSignIn }: { onSignIn: () => void }) {
  return (
    <div className="flex h-full flex-col items-center justify-center p-6 text-center">
      <div className="text-3xl" aria-hidden>
        🔐
      </div>
      <h2 className="mt-3 text-base font-semibold">Sign in with Zoom</h2>
      <p className="mt-2 max-w-sm text-sm text-gray-600">
        Connect your Zoom account so Levelheaded can load your case briefing and dial parties
        into the meeting.
      </p>
      <button type="button" className="btn-primary mt-4" onClick={onSignIn}>
        Authorize with Zoom
      </button>
    </div>
  );
}
